import { render } from "./MainDetalProductPage.vue?vue&type=template&id=2a970c44&scoped=true"
import script from "./MainDetalProductPage.vue?vue&type=script&lang=js"
export * from "./MainDetalProductPage.vue?vue&type=script&lang=js"

import "./MainDetalProductPage.vue?vue&type=style&index=0&id=2a970c44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a970c44"]])

export default __exports__